import React from "react";
import Badge, { BadgeProps } from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { useEffect, useState,useRef  } from "react";
import PublishIcon from "@mui/icons-material/Publish";
import Tooltip from "@mui/material/Tooltip";
import { useStoreDispatch, useStoreSelector } from "../../store/Hooks";
import { navSliceActions } from "../../store/slices/NavSlice";
import CommitData from "../../models/interactions/commit/CommitData";


const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -3,
    top: 3,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));

interface CommitButtonProps {
  setID: number | null;
  parentID: number | null;
  root?: boolean | undefined; // is this element being used in root component?
  standardTheme?: boolean | undefined;
  shared?:boolean | undefined;
}

const CommitButton = (props: CommitButtonProps) => {
  const [isInitialCommitButton, setIsInitialCommitButton] = useState<boolean>(true);
  const [commitData, setCommitData] = useState<CommitData | null>(null);

  useEffect(() => {
    if(isInitialCommitButton){
      setIsInitialCommitButton(false);
      getDiffAndSetLocalState()
    }
  }, []);

  const getDiffAndSetLocalState = async () =>{    
    const commitDataLocal = new CommitData([],[],[],[],[],
      props.shared ? props.parentID : props.setID, 
      props.parentID,props.shared || false)
    await commitDataLocal.getDiff(); // populate object instance with diff data
    setNumChildInteractionDiffs(commitDataLocal.commitFetchData?.numChildInteractionDiffs  || 0)
    setTooltipLabel(commitDataLocal.commitFetchData?.toolTipLabel || "There are currently no interactions to commit")
    setCommitData(commitDataLocal);
  }

  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  
  useEffect(() => {
    // as soon as we can, we want to find the diff right away
    // (only do it this way the first time this component is rendered)
    getDiffAndSetLocalState()
    intervalRef.current = setInterval(() => {
      getDiffAndSetLocalState()
    }, 10000);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };

  }, []);

  const [numChildInteractionDiffs, setNumChildInteractionDiffs] =
    useState<number>(0);

  const [tooltipLabel, setTooltipLabel] = useState<string>(
    "There are currently no interactions to commit",
  );

  const dispatch = useStoreDispatch();

  const handleOpenCommit = async () => {
    dispatch(
      navSliceActions.openRightDrawer({
        content: commitData,
        type: "commit"
      }),
    );
  };

  let mainButtonStyle = {};
  if (props.root && !props.standardTheme) {
    mainButtonStyle = {
      color: "white",
      fontWeight: "bold",
      padding: "13px",
    };
  }

  return (
    <Tooltip title={tooltipLabel}>
      <IconButton onClick={handleOpenCommit} style={mainButtonStyle}>
        <StyledBadge badgeContent={numChildInteractionDiffs} color="error">
          <PublishIcon />
        </StyledBadge>
      </IconButton>
    </Tooltip>
  );
};

export default CommitButton;
